import { isOnlySpaces, maxLength } from 'src/modules/user/constants/configuration-form'
import * as yup from 'yup'
import 'yup-phone'

export const phoneLength = 5

export const eventEditSchema = yup
  .object()
  .shape(
    {
      sender_name: yup
        .string()
        .nullable()
        .notRequired()
        .when('sender_name', {
          is: (value) => value?.length,
          then: (rule) =>
            rule.max(maxLength, 'From must be shorter than 160 characters').matches(isOnlySpaces, {
              excludeEmptyString: true,
              message: 'From cannot contain only blank spaces',
            }),
        }),
      receiver_numbers: yup
        .array()
        .of(
          yup.object().shape({
            country: yup.string().nullable(),
            phone: yup
              .string()
              .required('Customer number cannot be empty')
              .min(phoneLength, 'Invalid customer number length')
              .phone('', false, 'Customer number must be a valid phone number'),
          }),
        )
        .max(10, 'Maximum of 10 phone numbers allowed'),
      location: yup
        .string()
        .nullable()
        .max(maxLength, 'Meeting location must be shorter than 160 characters')
        .matches(isOnlySpaces, {
          excludeEmptyString: true,
          message: 'Meeting location cannot contain only blank spaces',
        }),
      confirmation_enabled: yup.boolean(),
      confirmation_message: yup.string().when('confirmation_enabled', {
        is: true,
        then: (schema) => schema.required('Message is required'),
        otherwise: (schema) => schema.nullable(),
      }),
      confirmation_offsets: yup
        .array()
        .of(yup.number())
        .when('confirmation_enabled', {
          is: true,
          then: (schema) => schema.min(1, 'At least one timing is required'),
          otherwise: (schema) => schema.nullable(),
        }),
      reminder_enabled: yup.boolean(),
      reminder_message: yup.string().when('reminder_enabled', {
        is: true,
        then: (schema) => schema.required('Message is required'),
        otherwise: (schema) => schema.nullable(),
      }),
      reminder_offsets: yup
        .array()
        .of(yup.number())
        .when('reminder_enabled', {
          is: true,
          then: (schema) => schema.min(1, 'At least one timing is required'),
          otherwise: (schema) => schema.nullable(),
        }),
      follow_up_enabled: yup.boolean(),
      follow_up_message: yup.string().when('follow_up_enabled', {
        is: true,
        then: (schema) => schema.required('Message is required'),
        otherwise: (schema) => schema.nullable(),
      }),
      follow_up_offsets: yup
        .array()
        .of(yup.number())
        .when('follow_up_enabled', {
          is: true,
          then: (schema) => schema.min(1, 'At least one timing is required'),
          otherwise: (schema) => schema.nullable(),
        }),
    },
    [['sender_name', 'sender_name']],
  )
  .test('at-least-one-message-type', 'At least one message type must be enabled', function (value) {
    return value.confirmation_enabled || value.reminder_enabled || value.follow_up_enabled
  })
